export const Button = {
  variants: {
    brand: {
      variant: 'ghost',
      color: '#8B2950',
      border: '1px solid #8B2950',
    },
  },
}
